export const ADMIN_LOGOUT = '[Admin] logout request';
